import { ContactFormPage } from "./-pages/contactFormPage";
import { createFileRoute } from "@tanstack/react-router";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/contacts/create")({
  component: RouteComponent,
});

function RouteComponent() {
  useBreadCrumbs([
    { title: "Contacts", link: `/${location.pathname.split("/")[1]}/data/contacts` },
    { title: "Create", link: `/${location.pathname.split("/")[1]}/data/contacts/create` },
  ]);
  return <ContactFormPage />;
}
